import * as React from 'react';



export default class Mobile extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
        <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" className={this.props.className}>
        <defs></defs>
        <g id="Page-1" stroke="" strokeWidth="1" fill="none" fillRule="evenodd">
              <g id="Carrier-details" transform="translate(-1286.000000, -302.000000)" stroke="">
                  <g id="Group-62" transform="translate(1061.000000, 108.000000)">
                      <g id="Group-37" transform="translate(10.000000, 123.000000)">
                          <g id="Group-80" transform="translate(0.000000, 63.000000)">
                              <g id="Group-76" transform="translate(211.000000, 4.000000)">
                                  <g id="Phone" transform="translate(4.000000, 3.716500)">
                                      <path d="M11.04584,13.59992 L5.14744,13.59992 C4.73384,13.59992 4.39944,13.26552 4.39944,12.85272 L4.39944,3.37352 C4.39944,2.96152 4.73384,2.62712 5.14744,2.62712 L11.04584,2.62712 C11.45944,2.62712 11.79384,2.96152 11.79384,3.37352 L11.79384,12.85272 C11.79384,13.26552 11.45944,13.59992 11.04584,13.59992 Z" id="Stroke-2"></path>
                                      <line x1="4.69112" y1="4.43856" x2="11.50232" y2="4.43856" id="Stroke-4"></line>
                                      <line x1="4.54352" y1="11.07408" x2="10.32112" y2="11.07408" id="Stroke-6" strokeLinecap="round" strokeLinejoin="round"></line>
                                      <line x1="7.624" y1="12.46784" x2="8.5696" y2="12.46784" id="Stroke-8" strokeLinecap="round" strokeLinejoin="round"></line>
                                  </g>
                              </g>
                          </g>
                      </g>
                  </g>
              </g>
          </g>
    </svg>
    )
  }
}
